// Must match the Fade component timeout in BaseGrinNotification
export const NOTIFICATION_FADE_DURATION = 500

export const HOVER_CHECK_DELAY = NOTIFICATION_FADE_DURATION + 100
export const DELETION_EVENT_DELAY = 100
export const POST_DELETION_CHECK_DELAY = NOTIFICATION_FADE_DURATION

export const EVENTS = {
  NOTIFICATION_DELETED: 'notificationDeleted'
}
